export const checkOperationsEnabled = (): boolean => {
  return import.meta.env.VITE_FEATURE_SHOW_OPERATIONS !== 'false';
};

export const checkAvailabilityEnabled = (): boolean => {
  return import.meta.env.VITE_FEATURE_SHOW_AVAILABILITY !== 'false';
};

export const checkOptimisationEmailEnabled = (): boolean => {
  return import.meta.env.VITE_FEATURE_OPTIMISATION_EMAIL !== 'false';
};

export const checkAvailabilityDownloadEnabled = (): boolean => {
  return import.meta.env.VITE_FEATURE_AVAILABILITY_DOWNLOAD !== 'false';
};
